import React from "react"
import {
	Grid,
	Typography,
	Chip,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Card,
	Box
} from "@material-ui/core"
import {
	ExpandMore as ExpandMoreIcon,
	EmojiObjects as LightbulbIcon,
	FormatQuoteOutlined as FormatQuoteIcon
} from "@material-ui/icons"

import { MeetingAnalysis, MeetingTopicScores } from "@/services/MeetingAnalyzerService"

import useMeetingAnalyzerStyles from "@/pages/Admin/MeetingAnalyzer/Detail/styles"
import useStyles from "@/pages/Admin/MeetingAnalyzer/Detail/ImprovementsCard/styles"
import { meetingTopicDefinitions } from "@/utils/meetingAnalyzer"

type ImprovementsCardProps = {
	analysis: MeetingAnalysis
}

const ImprovementsCard: React.FC<ImprovementsCardProps> = (props) => {
	const { analysis } = props

	const meetingAnalyzerClasses = useMeetingAnalyzerStyles()
	const classes = useStyles()

	if (!analysis.output) {
		return null
	}

	const improvements = analysis.output.improvementOpportunities

	const getTopicLabel = (topic: keyof MeetingTopicScores): string => {
		const topicDefinition = meetingTopicDefinitions.find(definition => definition.key === topic)

		return topicDefinition?.label ?? topic
	}

	return (
		<Card className={meetingAnalyzerClasses.card}>
			<Grid container direction="column" spacing={2}>
				<Grid item>
					<Typography className={meetingAnalyzerClasses.cardTitle}>
						Oportunidades de melhoria
					</Typography>
				</Grid>
				<Grid item>
					<Typography className={meetingAnalyzerClasses.cardSubtitle}>
						Momentos que, se conduzidos diferente, mudariam o resultado da reunião.
					</Typography>
				</Grid>
				<Grid item>
					{improvements.map((improvement, index) => (
						<Accordion key={index} elevation={0} className={classes.flatAccordion}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								className={classes.flatAccordionSummary}
							>
								<Grid container alignItems="center" spacing={2}>
									<Grid item>
										<Chip label={getTopicLabel(improvement.topic)} size="small" className={classes.improvementTopicChip} />
									</Grid>
									<Grid item xs>
										<Typography className={meetingAnalyzerClasses.topicLabel}>
											{improvement.excerpt}
										</Typography>
									</Grid>
								</Grid>
							</AccordionSummary>
							<AccordionDetails className={classes.flatAccordionDetails}>
								<Grid container direction="column" spacing={2}>
									<Grid item>
										<Typography className={meetingAnalyzerClasses.quoteBox}>
											<FormatQuoteIcon fontSize="small" className={meetingAnalyzerClasses.quoteIcon} />
											{improvement.excerpt}
										</Typography>
									</Grid>
									<Grid item>
										<Box className={classes.recommendationBox}>
											<Grid item>
												<Grid container alignItems="center" spacing={1}>
													<Grid item>
														<LightbulbIcon fontSize="small" color="primary" />
													</Grid>
													<Grid item>
														<Typography className={classes.recommendationLabel}>
															COMO O CLOSER PODERIA TER APROVEITADO
														</Typography>
													</Grid>
												</Grid>
											</Grid>
											<Grid item>
												<Typography className={classes.recommendationText}>
													{improvement.suggestion}
												</Typography>
											</Grid>
										</Box>
									</Grid>
								</Grid>
							</AccordionDetails>
						</Accordion>
					))}
				</Grid>
			</Grid>
		</Card>
	)
}

export default ImprovementsCard
